const isSafeMessage = (value) => {
  if (typeof value !== 'string') return false;
  const message = value.trim();
  return Boolean(message)
    && !/<(?:!doctype|html|body|script)\b/i.test(message)
    && !/^(?:traceback|csrf failed:)/i.test(message);
};

const firstReadableMessage = (value) => {
  if (isSafeMessage(value)) return value.trim();
  if (Array.isArray(value)) {
    for (const item of value) {
      const message = firstReadableMessage(item);
      if (message) return message;
    }
  }
  if (value && typeof value === 'object') {
    for (const item of Object.values(value)) {
      const message = firstReadableMessage(item);
      if (message) return message;
    }
  }
  return '';
};

export const getApiErrorMessage = (error, fallback, preferredFields = []) => {
  const status = error?.response?.status;
  if (status === 401) return 'La sesión no es válida. Inicie sesión nuevamente.';
  if (status === 403) return 'No tiene permisos para realizar esta operación.';

  const data = error?.response?.data;
  if (isSafeMessage(data)) return data.trim();

  if (data && typeof data === 'object' && !Array.isArray(data)) {
    const prioritizedFields = [
      ...preferredFields,
      'detail',
      'error',
      'non_field_errors',
      'errors',
    ];
    const visited = new Set();

    for (const field of prioritizedFields) {
      if (visited.has(field)) continue;
      visited.add(field);
      const message = firstReadableMessage(data[field]);
      if (message) return message;
    }

    for (const [field, value] of Object.entries(data)) {
      if (visited.has(field) || field === 'code') continue;
      const message = firstReadableMessage(value);
      if (message) return message;
    }
  }

  if (!error?.response && !error?.isAxiosError) {
    const localMessage = firstReadableMessage(error?.message);
    if (localMessage && !/^Request failed with status code\b/i.test(localMessage)) {
      return localMessage;
    }
  }

  return fallback;
};

